import {
  Box,
  FloraTypography,
  Image,
  styled,
  ModalCloseButton as FloraModalCloseButton,
  FloraButton,
} from '@grupoboticario/flora-react'
import { PlayCircleFillIcon } from '@grupoboticario/flora-react-icons'

export const ThumbnailContainer = styled(Box, {
  width: '35vw',
  '@tablet': {
    width: '180px',
  },
  cursor: 'pointer',
})

export const Thumbnail = styled(Image, {
  // keeping the aspect ratio at different screen sizes
  height: 'calc(35vw * 1.86)',
  objectFit: 'cover',
  borderRadius: '$small',
  '@tablet': {
    height: '330px',
  },
})

export const ThumbnailOverlay = () => (
  <Box
    css={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      backgroundColor: '#000000',
      borderRadius: '$small',
      width: '100%',
      height: '100%',
      opacity: 0.2,
    }}
  />
)

export const VideoTitle = styled(FloraTypography, {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-line-clamp': 2,
  '-webkit-box-orient': 'vertical',
})

export const PlayIcon = styled(PlayCircleFillIcon, {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '@tablet': { svg: { size: '36px' } },
})

export const ModalCloseButton = styled(FloraModalCloseButton, {
  top: '$14',
  right: '$4',
  'svg, path': {
    width: '$6',
    height: '$6',
    fill: '$backgroundPrimary !important',
  },
  border: '1px solid $backgroundPrimary',
  padding: '$1',
  zIndex: '$popover',
})

export const AudioControllerButton = styled(FloraButton, {
  position: 'absolute',
  top: 'calc($1 * 28)',
  right: '$4',
  height: 'auto !important',
  padding: '$1 !important',
  'svg, path': {
    width: '$6',
    height: '$6',
  },
})

const bordersGradientStyles = {
  content: "''",
  position: 'absolute',
  left: 0,
  width: '100%',
  height: '95px',
}

export const PlayerContainer = styled(Box, {
  pointerEvents: 'none',
  position: 'relative',
  height: '100vh',
  width: '100vw',
  '&:before': {
    ...bordersGradientStyles,
    bottom: 0,
    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
    zIndex: '$docked',
  },
  '&:after': {
    ...bordersGradientStyles,
    top: 0,
    background: 'linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%)',
  },
  '.react-player': {
    position: 'absolute',
    top: 0,
    left: 0,
  },
})
